export default class Event {
    constructor(public readonly type: string) {}
}



// WEBPACK FOOTER //
// ./src/application/core/Event.ts